import { type FC } from 'react';
import { useBoostFirebaseEvents } from '@common/hooks/boost-firebase-events';
import { FactoryActiveBoostItem } from '@components/ActiveBoostItem/FactoryActiveBoostItem/FactoryActiveBoostItem';
import { BoostCard } from '@components/BoostCard/BoostCard';
import { BoostFirebaseEventsContext } from '@context/BoostFirebaseEventContext';
import { useModal } from '@context/ModalContext';
import {
  selectActiveBoostForFactory,
  selectFactories,
  selectFactoryBoostList,
  selectFreeBoostForFactory,
  selectVipBoostForFactory,
} from '@redux/selectors/factoryReducer';
import { useAppSelector } from '@redux/store';

import PlantBoostModal from '../PlantBoostModal';

const FactoriesBoostModal: FC = () => {
  const activeBoosts = useAppSelector(selectFactoryBoostList);
  const { isFactoryBoostModalOpen, setIsFactoryBoostModalOpen } = useModal();
  const freeBoost = useAppSelector((state) => selectFreeBoostForFactory(state));
  const vipBoost = useAppSelector((state) => selectVipBoostForFactory(state));
  const factoriesList = useAppSelector(selectFactories);
  const activeBoost = useAppSelector(selectActiveBoostForFactory);
  const events = useBoostFirebaseEvents({}, activeBoost, factoriesList);

  return (
    <BoostFirebaseEventsContext.Provider value={events}>
      <PlantBoostModal
        plantType="Factory"
        activeBoostList={activeBoosts}
        activeBoostItem={(props) => (
          <FactoryActiveBoostItem key={props.id} {...props} />
        )}
        boostCardList={[freeBoost, vipBoost].map((boost) => ({
          ...boost,
          variant: 'big',
          plantType: 'Factory',
        }))}
        boostCardItem={(props) => (
          <BoostCard key={props.boostType} {...props} />
        )}
        isPlantBoostOpen={isFactoryBoostModalOpen}
        setOpenPlantBoostModal={setIsFactoryBoostModalOpen}
      />
    </BoostFirebaseEventsContext.Provider>
  );
};

export { FactoriesBoostModal };
